// import gsap from 'gsap'
import { bp, mm, sel, selAll } from '../utils'
// import SplitText from 'gsap/SplitText'

// gsap.registerPlugin(SplitText)

export default function heroV2() {
  // const shipHero = false || skipHeroInit
  const hero$ = sel('.hero.is--v2')
  if (!hero$) return
  // console.log('heroV2.js loaded')
  const heroC$ = hero$.sel('.hero__c--epic')
  heroC$?.classList.remove('gsap-hide')

  gsap.set(hero$, { zIndex: 30 })

  mm.add(bp.tabUp, () => {
    // const compInfo$ = header$.querySelector('.hero__info--epic')
    const heroP$ = hero$.querySelector('.hero__p--epic')
    const heroBtn1$ = hero$.querySelectorAll('.btn')[0]
    const heroBtn2$ = hero$.querySelectorAll('.btn')[1]
    const heroBg$ = hero$.sel('.bg-w') || hero$.sel('.hero__bg-w--vid')
    const heroTag$ = hero$.querySelector('.hero__tag--epic')

    const compHsT = SplitText.create('.h1--epic', { type: 'chars, words' }) // words to keep the initial wrapping
    gsap
      .timeline({ defaults: { ease: 'power4.out', duration: 2 } })
      .from(
        compHsT.chars,
        // '.h1--epic',
        {
          autoAlpha: 0,
          filter: 'blur(50px)',
          // ...ifChromeBlur,
          stagger: {
            amount: 1.25,
          },
          // duration: 0.5,
          duration: 1.05,
          ease: 'none',
        },
        0.5
      )
      .from(heroP$, { autoAlpha: 0, y: -20, duration: 2 }, '>-0.5')
      .from(heroBtn1$, { autoAlpha: 0, y: -20 }, '<0.25')
      .from(heroBtn2$, { autoAlpha: 0, y: -20 }, '<0.1')
      // .from(heroBg$, { autoAlpha: 0, duration: 10, ease: 'none' }, '<+0.15')
      .from(heroTag$, { autoAlpha: 0 }, '<+0.15')
  })
}
